/**
 * usar-instalacao.ts — o estado de "dá para instalar?" para quem desenha tela.
 *
 * Mora separado de `instalacao.ts` de propósito: aquele arquivo é o porte 1:1
 * do projeto irmão e não conhece React. Aqui fica o único pedaço que precisa de
 * React — e ele existe porque o `beforeinstallprompt` do Chrome **pode chegar
 * depois** de a tela montar: o navegador não garante o momento. Uma olhada por
 * segundo nos primeiros segundos resolve sem ficar ouvindo evento para sempre.
 *
 * Três lugares perguntam a mesma coisa (a faixa do início, o item do menu do
 * perfil e a tela /public/instalar); sem isto aqui seriam três cópias do mesmo
 * `setInterval`.
 */
import { useEffect, useState } from 'react';
import { detectar, temPromptNativo } from './instalacao';
import type { Ambiente } from './instalacao';

export function usarInstalacao(): { ambiente: Ambiente | null; temPrompt: boolean } {
  const [ambiente, setAmbiente] = useState<Ambiente | null>(null);
  const [temPrompt, setTemPrompt] = useState(false);

  useEffect(() => {
    setAmbiente(detectar());
    setTemPrompt(temPromptNativo());
    let tentativas = 0;
    const t = setInterval(() => {
      setTemPrompt(temPromptNativo());
      if (++tentativas >= 8) clearInterval(t);
    }, 1000);
    return () => clearInterval(t);
  }, []);

  return { ambiente, temPrompt };
}
